// src/components/molecules/ChallengeCreator/CrowdFundingSwitch.js

import React from "react";
import { Grid, Typography, Switch } from "@mui/material";

const CrowdFundingSwitch = ({
  formData,
  handleCrowdFundingToggleChange,
  theme,
  disabled,
}) => {
  return (
    <>
      {/* Allow Buys Toggle Section */}
      <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
        <Grid item xs={12}>
          <Typography
            variant="body1"
            sx={{ color: "white", fontFamily: "basic-sans" }}
          >
            Allow Crowd Funding
          </Typography>
        </Grid>

        <Grid item>
          <Switch
            checked={!!formData.allowCrowdFunding}
            onChange={handleCrowdFundingToggleChange}
            color="default" // Change the default color to prevent MUI's primary styling
            disabled={disabled} // Disable the switch when the prop is true
            sx={{
              "& .MuiSwitch-track": {
                backgroundColor: formData.allowCrowdFunding
                  ? theme.colors.green
                  : theme.colors.red,
                opacity: 1, // Ensure the track color is strong
              },
              "& .MuiSwitch-thumb": {
                backgroundColor: formData.allowCrowdFunding
                  ? theme.colors.green
                  : theme.colors.red,
              },
              "& .MuiSwitch-switchBase.Mui-checked": {
                "& + .MuiSwitch-track": {
                  backgroundColor: theme.colors.green,
                  opacity: 0.5,
                },
              },
              "& .MuiSwitch-switchBase": {
                "&:not(.Mui-checked) + .MuiSwitch-track": {
                  backgroundColor: theme.colors.red,
                  opacity: 0.5,
                },
              },
            }}
          />
        </Grid>

        <Grid item>
          <Typography
            variant="body2"
            sx={{
              color: formData.allowCrowdFunding
                ? theme.colors.green
                : theme.colors.red,
              fontFamily: "basic-sans",
            }}
          >
            {formData.allowCrowdFunding ? "YES" : "NO"}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default CrowdFundingSwitch;
